import { useState } from "react";
import Button from "./Button";
import { Text } from "./Form";

const TextEditor = ({ initialValue, onSave }) => {
  const [value, setValue] = useState(initialValue || "");

  return (
    <div>
      <Text
        className="-mx-[2px]"
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <div className="mt-2">
        <Button primary onClick={() => onSave(value)}>
          Save
        </Button>
      </div>
    </div>
  );
};

export default TextEditor;
